// extracted by mini-css-extract-plugin
module.exports = {"longformContentSection":"style_longformContentSection__MxJft g-type-body-long a_a__m5C0H blockquote_blockquote__a4e7y hr_hr__yLdDP ol-ul-lists_olUlLists__S2nQg"};